import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateSimXScenarioPackageRequest } from '../models/requests/create-simx-scenario-package-request.model';
import { GetSimXScenarioPackageRequest } from '../models/requests/get-simx-scenario-package-request.model';
import { GetSimXScenarioPackagesRequest } from '../models/requests/get-simx-scenario-packages-request.model';
import { UpdateSimXScenarioPackageRequest } from '../models/requests/update-simx-scenario-package-request.model';
import { CreateSimXScenarioPackageResponse } from '../models/responses/create-simx-scenario-package-response.model';
import { DeleteSimXScenarioPackageResponse } from '../models/responses/delete-simx-scenario-package-response.model';
import { GetSimXScenarioPackageResponse } from '../models/responses/get-simx-scenario-package-response.model';
import { GetSimXScenarioPackagesResponse } from '../models/responses/get-simx-scenario-packages-response.model';
import { UpdateSimXScenarioPackageResponse } from '../models/responses/update-simx-scenario-package-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class ScenarioPackageDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getScenarioPackages(
    request: GetSimXScenarioPackagesRequest = {},
  ): Observable<GetSimXScenarioPackagesResponse> {
    const url = this._dataService.scenarioPackagesUrl();
    return this._http.post<GetSimXScenarioPackagesResponse>(url, request);
  }

  getScenarioPackage(
    scenarioPackageId: string,
    request: GetSimXScenarioPackageRequest = {},
  ): Observable<GetSimXScenarioPackageResponse> {
    const url = this._dataService.scenarioPackagesUrl(scenarioPackageId);
    return this._http.post<GetSimXScenarioPackageResponse>(url, request);
  }

  createScenarioPackage(
    request: CreateSimXScenarioPackageRequest,
  ): Observable<CreateSimXScenarioPackageResponse> {
    const url = this._dataService.scenarioPackagesUrl();
    return this._http.put<CreateSimXScenarioPackageResponse>(url, request);
  }

  updateScenarioPackage(
    scenarioPackageId: string,
    request: UpdateSimXScenarioPackageRequest,
  ): Observable<UpdateSimXScenarioPackageResponse> {
    const url = this._dataService.scenarioPackagesUrl(scenarioPackageId);
    return this._http.patch<UpdateSimXScenarioPackageResponse>(url, request);
  }

  deleteScenarioPackage(
    scenarioPackageId: string,
  ): Observable<DeleteSimXScenarioPackageResponse> {
    const url = this._dataService.scenarioPackagesUrl(scenarioPackageId);
    return this._http.delete<DeleteSimXScenarioPackageResponse>(url);
  }
}
